import { createFeatureSelector, createSelector } from '@ngrx/store';
import { appointmentFeatureKey, AppointmentState } from './appointment.reducer';

export const selectAppointmentState = createFeatureSelector<AppointmentState>(appointmentFeatureKey);

export const selectAppointments = createSelector(selectAppointmentState, (state) => state.items);
export const selectAppointmentsLoading = createSelector(selectAppointmentState, (state) => state.loading);
export const selectAppointmentsSaving = createSelector(selectAppointmentState, (state) => state.saving);
export const selectAppointmentSubmitted = createSelector(selectAppointmentState, (state) => state.submitted);
export const selectAppointmentError = createSelector(selectAppointmentState, (state) => state.error);

export const selectPendingAppointments = createSelector(selectAppointments, (appointments) =>
  appointments.filter((appointment) => appointment.status === 'pending'),
);

export const selectCalendarAppointments = createSelector(selectAppointments, (appointments) =>
  appointments
    .filter((appointment) => appointment.status === 'booked' || appointment.status === 'pending')
    .sort((a, b) => {
      const aDate = a.scheduledStart || a.preferredDate || a.createdAt;
      const bDate = b.scheduledStart || b.preferredDate || b.createdAt;
      return aDate.localeCompare(bDate);
    }),
);
